<template>
  <v-app :style="{'background': $vuetify.theme.themes['light'].background}">
    <v-app-bar app dense color="white">

      <v-layout wrap v-if="this.$router.currentRoute.path.startsWith('/from-token')">
        <v-flex xs6 class="pt-3 pl-2">
          <h3 class="primary--text"><a href="/" style="text-decoration: none"><span class="secondary--text">ESN</span> Web Services</a></h3>
        </v-flex>
        <v-flex xs6>
          <v-tabs show-arrows optional color="primary">
            <v-spacer/>
            <nav-locale-selector/>
          </v-tabs>
        </v-flex>
      </v-layout>

      <v-layout wrap v-else-if="this.$router.currentRoute.path.startsWith('/consultant')">
        <v-flex xs6 class="pt-3 pl-2">
          <h3 class="primary--text"><a :href="user && user.loggedIn ? '/consultant/dossiers' : '/consultant'" style="text-decoration: none"><span class="secondary--text">ESN</span> Web Services</a></h3>
        </v-flex>
        <v-flex xs6>
          <v-tabs show-arrows optional>
            <v-spacer/>
            <consultant-logged-in-nav-locale-selector v-if="user && user.loggedIn === true && user.data" class="mr-8"/>
            <consultant-not-logged-in-nav-locale-selector v-if="user && user.loggedIn === false" class="mr-8"/>
            <v-tab @click="signOut(true)" v-if="user && user.loggedIn">
              {{ $t('e') }}
            </v-tab>
          </v-tabs>
        </v-flex>
      </v-layout>

      <v-layout wrap v-else>
        <v-flex xs2 class="pt-3 pl-2" v-if="!$vuetify.breakpoint.xs">
          <h3 class="primary--text"><a :href="user && user.loggedIn ? '/dossiers' : '/'" style="text-decoration: none"><span class="secondary--text">ESN</span> Web Services</a></h3>
        </v-flex>
        <v-flex xs10 v-if="user && user.loggedIn">
          <v-tabs show-arrows optional :color="this.$router.currentRoute.path === '/subscribe' ? 'secondary' : 'primary'">
            <v-tab to="/dossiers" v-if="!this.$router.currentRoute.path.startsWith('/onboarding')" exact>
              <v-icon left small>mdi-format-list-bulleted</v-icon>
              {{ $t('a') }}
            </v-tab>
            <v-tab to="/dossiers/create" v-if="!this.$router.currentRoute.path.startsWith('/onboarding') && user.company && user.company.dossiersLeftNb > 0">
              <v-icon left small>mdi-plus</v-icon>
              {{ $t('b') }}
            </v-tab>
            <v-tab to="/subscribe" v-if="!this.$router.currentRoute.path.startsWith('/onboarding') && user.company && !companyHasOrHadSubscription && user.company.onlyDisplayedPlanIds">
              <v-btn to="/subscribe" color="secondary" >
                <v-icon left small class="white--text">mdi-arrow-right</v-icon>
                <span class="white--text">{{ $t('c') }}</span>
              </v-btn>
            </v-tab>
            <v-tab to="/admin" v-if="isAdmin" color="secondary">
              <v-btn to="/admin" color="secondary" >
                <v-icon left small class="white--text">mdi-one-up</v-icon>
                <span class="white--text">Admin</span>
              </v-btn>
            </v-tab>
            <v-spacer></v-spacer>
            <!-- <v-tab to="/roadmap" v-if="!this.$router.currentRoute.path.startsWith('/onboarding')">
              <v-icon left small>mdi-road-variant</v-icon>
              {{ $t('roadmap') }}
            </v-tab> -->
            <v-tab to="/account" v-if="!this.$router.currentRoute.path.startsWith('/onboarding')">{{ $t('d') }}</v-tab>
            <v-tab @click="signOut(false)">{{ $t('e') }}</v-tab>
          </v-tabs>
        </v-flex>
        <v-flex xs10 v-else>
          <v-tabs show-arrows optional :color="this.$router.currentRoute.path === '/book-demo' ? 'secondary' : 'primary'">
            <v-tab :to="'/' + langParamStr">{{ $t('f') }}</v-tab>
            <!-- <v-tab :to="'/pricing' + langParamStr">{{ $t('g') }}</v-tab> -->
            <v-spacer></v-spacer>
            <v-tab :to="'/book-demo' + langParamStr" class="mr-8">
              <v-btn class="secondary white--text">{{ $t('bookDemo') }}</v-btn>
            </v-tab>
            <nav-locale-selector/>
            <v-tab :to="'/login' + langParamStr">{{ $t('h') }}</v-tab>
            <v-tab :to="'/signup' + langParamStr">{{ $t('i') }}</v-tab>
          </v-tabs>
        </v-flex>
      </v-layout>
    </v-app-bar>
    <v-main>
      <router-view/>
    </v-main>
    <footer>
      <cookie-law>
        <div slot-scope="props">
          <small class="white--text mx-12">
            <span class="mr-2">🍪</span>Ce site utilise des cookies pour optimiser votre expérience de navigation. 
            Pour plus d'informations, vous pouvez consulter nos <a class="white--text" target="_blank" href="https://firebasestorage.googleapis.com/v0/b/esnwebservices-prod.appspot.com/o/public%2FCGU%20ESN%20Web%20Services.pdf?alt=media&token=e888057c-0e79-4bd7-bdbd-05afc66c13f9">Conditions Générales d'Utilisation</a>.
          </small>
          <v-btn class="secondary" @click="props.accept"><span>OK</span></v-btn>
        </div>
      </cookie-law>
    </footer>
  </v-app>
</template>

<script>
import vuei18n from '@/i18n'
import CookieLaw from 'vue-cookie-law'
import { mapGetters } from "vuex";

import NavLocaleSelector from '@/components/NavLocaleSelector'
import ConsultantNotLoggedInNavLocaleSelector from '@/components/consultant/ConsultantNotLoggedInNavLocaleSelector'
import ConsultantLoggedInNavLocaleSelector from '@/components/consultant/ConsultantLoggedInNavLocaleSelector'

export default {
  components: {
    CookieLaw,
    NavLocaleSelector,
    ConsultantNotLoggedInNavLocaleSelector,
    ConsultantLoggedInNavLocaleSelector
  },
  async mounted() {
    // Add crisp chat on production
    if (process.env.VUE_APP_ENV === 'production') {
      window.$crisp=[];window.CRISP_WEBSITE_ID="8baf9f87-3275-46d6-90b6-07403cc70aa9";(function(){ let d=document; let s=d.createElement("script"); s.src="https://client.crisp.chat/l.js"; s.async=1;d.getElementsByTagName("head")[0].appendChild(s);})();  // eslint-disable-line
    }
  },
  computed: {
    ...mapGetters({
      user: "user"
    }),
    langParamStr() {
      const lang = this.$route.query.lang
      if (lang && lang !== 'fr') {
        return `?lang=${lang}`
      }
      return ''
    },
    companyHasOrHadSubscription() {
      return this.user.company && this.user.company.hasOrHadSubscription
    },
    isAdmin() {
      return this.user.data && this.user.data.isAdmin
    },
    vuei18nLocale() {
      return vuei18n.locale
    }
  },
  methods: {
    signOut(isConsultant) {
      const locale = this.user.data.locale
      this.$auth.signOut()
        .then(() => this.redirectWhenUserStateIsNotLoggedInAnymore(locale, isConsultant))
    },
    redirectWhenUserStateIsNotLoggedInAnymore(locale, isConsultant) {
      if (this.user.loggedIn) {
        setTimeout(() => this.redirectWhenUserStateIsNotLoggedInAnymore(locale, isConsultant), 10)
      } else {
        const homeRoute = isConsultant ? `/consultant/?lang=${locale}` : `/?lang=${locale}`
        this.$router.push(homeRoute)
      }
    },
  },
  watch: {
    vuei18nLocale: {
      handler(val) {
        if (val) this.$auth.languageCode = val
      }
    }
  }
}
</script>

<style>
  .v-btn {
    text-transform: none !important;
  }
  
  .v-tab {
    text-transform: none !important;
  }

  .Cookie {
    background-color: #37474f !important;
  }

  .Cookie__content {
    background-color: #37474f !important;
  }

  .Cookie__button {
    background-color: #00c853;
    border-radius: 20 !important;
  }

  .dragSelectButton {
    margin-top: -2px !important;
  }

  .fullWindowHeight {
    min-height:calc(100vh - 48px)
  }
  
  .greyBackground {
    background-color: #37474f !important;
  }
  
  .whiteBackground {
    background-color: white !important;
  }

  .outlinedButtonWhiteBackground {
    background-color: white !important;
  }

  .disabledCursor {
    cursor: not-allowed;
  }

  .textAsLink {
    text-decoration: underline;
    cursor: pointer
  }

  .vDialogWithoutShadow {
    box-shadow: none !important
  }

  .upload-btn-wrapper {
    overflow: hidden;
  }

  .upload-btn-wrapper input[type=file] {
    font-size: 100px;
    position: absolute;
    left: -20px;
    top: -20px;
    opacity: 0;
  }

  /* PROFILE */

  .leftCell {
    font-weight: bold;
    border-right: 1px solid rgba(0, 0, 0, 0.12);
  }

  .cursorPointer {
    cursor: pointer;
  }

  .hoveredBackground {
    background-color: rgba(0, 0, 0, 0.12) !important;
  }

  .quillAsHtml > p {
    margin: 0;
  }

  .quillAsHtml > ul > li.ql-indent-0 {
    margin-left: 10px;
  }
  .quillAsHtml > ul > li.ql-indent-1 {
    margin-left: 50px;
  }
  .quillAsHtml > ul > li.ql-indent-2 {
    margin-left: 90px;
  }
  .quillAsHtml > ul > li.ql-indent-3 {
    margin-left: 130px;
  }
  .quillAsHtml > ul > li.ql-indent-4 {
    margin-left: 170px;
  }
  .quillAsHtml > ul > li.ql-indent-5 {
    margin-left: 210px;
  }
  .quillAsHtml > ul > li.ql-indent-6 {
    margin-left: 250px;
  }
  .quillAsHtml > ul > li.ql-indent-7 {
    margin-left: 290px;
  }
  .quillAsHtml > ul > li.ql-indent-8 {
    margin-left: 330px;
  }
  .quillAsHtml > ul > li.ql-indent-9 {
    margin-left: 370px;
  }


  .banner-without-padding .v-banner__wrapper {
    padding: 0px !important;
  }

  .v-tooltip__content {
    opacity: 1 !important;
  }

  .img-horizontal-flip {
    -moz-transform: scale(-1, 1);
    -o-transform: scale(-1, 1);
    -webkit-transform: scale(-1, 1);
    transform: scale(-1, 1);
  }
</style>

<i18n>
{
  "fr": {
    "a": "Vos dossiers",
    "b": "Nouveau dossier",
    "c": "S'abonner",
    "d": "Votre compte",
    "e": "Se déconnecter",
    "f": "Accueil",
    "g": "Tarifs",
    "h": "Se connecter",
    "i": "Créer votre compte",
    "bookDemo": "Planifier une démo",
    "roadmap": "Roadmap"
  },
  "en": {
    "a": "Your CVs",
    "b": "New CV",
    "c": "Subscribe",
    "d": "Account",
    "e": "Signout",
    "f": "Home",
    "g": "Pricing",
    "h": "Log in",
    "i": "Sign up",
    "bookDemo": "Book a demo",
    "roadmap": "Roadmap"
  }
}
</i18n>
